"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNewNoSki = function SvgNewNoSki(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.358 7.874 19.08a1 1 0 0 0 .689 1.235l.36.102a1 1 0 0 0 1.236-.688l1.154-4.063M10.5 9.838l1.007-3.542a1 1 0 0 0 .033-.366l-.069-.747c-.043-.463.242-.919.707-.92.24-.001.483.046.64.199.228.22.513.889.725 1.449a2.76 2.76 0 0 1 .052 1.726l-1.276 4.489m1.217 1.664 1.818-6.401a.998.998 0 0 0 .034-.366l-.07-.746c-.042-.463.243-.92.708-.921.24 0 .483.046.64.2.228.22.513.888.724 1.448.209.553.214 1.158.053 1.726L15.377 16m-2.822 1.242-.833 2.932a1 1 0 0 0 .688 1.235l.362.103a1 1 0 0 0 1.235-.689l.376-1.323M5.18 5.498 18.82 22.9",
    stroke: "#D0021B"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNewNoSki);
var _default = exports["default"] = Memo;